export default __webpack_public_path__ + "static/media/explorer_welcome_grafik.b0a92335.gif";